import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import {
  CLUB_MEMBERSHIP_REQUESTING,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING
} from 'redux/clubMemberships/constants';
import { get as getOrder } from 'redux/orders/sagas';

import {
  editClubShipmentItems,
  editClubVirtualShipmentItems,
  getClubSubscriptionShipmentVirtualCartLimited,
  getSubscriptionClubShipmentVirtualCart,
  processClubShipment,
  skipClubShipment,
  unskipClubShipment
} from './api';
import {
  EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEMS_REQUEST,
  EDIT_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS,
  PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
  RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
  SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST,
  UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST
} from './constants';

function* editItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      editClubShipmentItems,
      customerId(),
      action.clubSubscriptionShipmentId,
      action.payload
    );
    if (action.onSuccess) {
      yield call(getVirtualCart, {
        clubSubscriptionShipmentId: action.clubSubscriptionShipmentId
      });
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* resetVirtualItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    if (action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
      payload: { id: action.clubSubscriptionShipmentId }
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* editVirtualItems(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      editClubVirtualShipmentItems,
      customerId(),
      action.clubSubscriptionShipmentId,
      action.payload
    );
    yield put({
      type: GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS,
      payload: response.data,
      clubSubscriptionShipmentId: action.clubSubscriptionShipmentId
    });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* process(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      processClubShipment,
      customerId(),
      action.clubSubscriptionShipmentId
    );
    yield call(getOrder, { orderId: response.data.orderId });
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* skip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      skipClubShipment,
      customerId(),
      action.clubSubscriptionShipmentId
    );
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* unskip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      unskipClubShipment,
      customerId(),
      action.clubSubscriptionShipmentId
    );
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
    yield put({
      type: GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

export function* getVirtualCart(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    let response;
    if (!customerId()) {
      response = yield call(
        getClubSubscriptionShipmentVirtualCartLimited,
        action.clubSubscriptionShipmentId
      );
    } else {
      response = yield call(
        getSubscriptionClubShipmentVirtualCart,
        customerId(),
        action.clubSubscriptionShipmentId
      );
    }

    if (action.onSuccess) {
      action.onSuccess(response.data);
    }

    yield put({
      type: GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
      payload: response.data,
      clubSubscriptionShipmentId: action.clubSubscriptionShipmentId
    });
  } catch (err) {
    if ([404, 422, 429].includes(err.response.status)) {
      yield put({
        type: GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR,
        payload: { errorMessage: err.response.data.message },
        clubSubscriptionShipmentId: action.clubSubscriptionShipmentId
      });
    } else {
      if (action.onError) {
        action.onError();
      }
      yield call(addAPIError, err);
    }
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
  }
}

function* watchList() {
  yield takeLatest(
    EDIT_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
    editVirtualItems
  );
  yield takeLatest(
    RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST,
    resetVirtualItems
  );
  yield takeLatest(EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEMS_REQUEST, editItems);
  yield takeLatest(PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST, process);
  yield takeLatest(SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST, skip);
  yield takeLatest(UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST, unskip);
  yield takeEvery(
    GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST,
    getVirtualCart
  );
}

export default function* clubSubscriptionShipmentSagas() {
  yield all([watchList()]);
}
